import { tns } from "tiny-slider/src/tiny-slider";
var TwoColumnImageSliderBlock = /** @class */ (function () {
    function TwoColumnImageSliderBlock(element) {
        this.sliderBlock = element;
        this.sliderWrapper = this.sliderBlock.querySelector('.slider-wrapper');
        this.sliderContainer = this.sliderBlock.querySelector('.slider-content');
        if (this.sliderContainer && this.sliderContainer.childElementCount >= 2) {
            // If 2 or more images - set slider active
            this.sliderControlsWrapper = this.sliderWrapper.querySelector('.slider-controls');
            this.init();
        }
    }
    TwoColumnImageSliderBlock.prototype.init = function () {
        var slider = tns({
            container: this.sliderContainer,
            items: 1,
            slideBy: 1,
            loop: false,
            autoplay: false,
            controls: true,
            nav: false,
            navPosition: 'bottom',
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            // @ts-ignore
            prevButton: this.sliderControlsWrapper.querySelector('.previous-slide-toggle'),
            // @ts-ignore
            nextButton: this.sliderControlsWrapper.querySelector('.next-slide-toggle'),
            responsive: {},
        });
    };
    return TwoColumnImageSliderBlock;
}());
export default TwoColumnImageSliderBlock;
var twoColumnImageSliderBlocks = document.querySelectorAll('[data-two-column-image-slider-block]');
twoColumnImageSliderBlocks.forEach(function (twoColumnImageSliderBlocks) {
    new TwoColumnImageSliderBlock(twoColumnImageSliderBlocks);
});
